import React, { CSSProperties } from 'react';
import styles from './index.module.scss';
import tittleDecoration from '../../imgs/tittleDecoration.png';

export interface EnergyContentProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  extraContent?: React.ReactNode;
  style?: CSSProperties;
  img?: string;
  headerStyle?: CSSProperties;
}

const SubTitle: React.FC<EnergyContentProps> = props => {
  const { title, img, style, extraContent, headerStyle } = props;

  return (
    <div className={styles.personalFormContainer} style={style}>
      <div className={styles.headerWrapper} style={headerStyle}>
        {title ? (
          <div className={styles.formTitle}>
            <img src={img || tittleDecoration} alt="pic" className={styles.titleBorder} />
            {title}
          </div>
        ) : (
          <div />
        )}
        {extraContent ? extraContent : <div />}
      </div>

      {props.children}
    </div>
  );
};

export default SubTitle;
